import { Platform } from 'react-native'
import * as SecureStore from 'expo-secure-store'

const FLAG_KEY = 'crew.biometric.enabled'
const CREDS_KEY = 'crew.biometric.creds'
const KEYCHAIN_SERVICE = 'crewsaders.biometric'

const isWeb = Platform.OS === 'web'

const flagOptions: SecureStore.SecureStoreOptions = {
  keychainService: KEYCHAIN_SERVICE,
  keychainAccessible: SecureStore.AFTER_FIRST_UNLOCK_THIS_DEVICE_ONLY,
}

const credsOptions: SecureStore.SecureStoreOptions = {
  keychainService: KEYCHAIN_SERVICE,
  requireAuthentication: true,
  authenticationPrompt: 'Sign in to Crewsaders',
  keychainAccessible: SecureStore.WHEN_PASSCODE_SET_THIS_DEVICE_ONLY,
}

export interface StoredCredentials {
  email: string
  password: string
}

export const isBiometricLoginEnabled = async (): Promise<boolean> => {
  if (isWeb) return false
  try {
    const value = await SecureStore.getItemAsync(FLAG_KEY, flagOptions)
    return value === '1'
  } catch {
    return false
  }
}

export const saveCredentials = async (email: string, password: string): Promise<void> => {
  if (isWeb) {
    throw new Error('Biometric login is not supported on web')
  }

  const payload: StoredCredentials = { email, password }
  await SecureStore.setItemAsync(CREDS_KEY, JSON.stringify(payload), credsOptions)
  await SecureStore.setItemAsync(FLAG_KEY, '1', flagOptions)
}

export const getCredentials = async (): Promise<StoredCredentials | null> => {
  if (isWeb) return null

  const raw = await SecureStore.getItemAsync(CREDS_KEY, credsOptions)
  if (!raw) return null

  try {
    const parsed = JSON.parse(raw) as StoredCredentials
    if (typeof parsed?.email !== 'string' || typeof parsed?.password !== 'string') {
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export const clearCredentials = async (): Promise<void> => {
  if (isWeb) return

  await Promise.allSettled([
    SecureStore.deleteItemAsync(CREDS_KEY, credsOptions),
    SecureStore.deleteItemAsync(FLAG_KEY, flagOptions),
  ])
}
